// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__x_PuC","title":"styles_title__bnKCO","terms":"styles_terms__x04EQ","print":"styles_print__LtCPy","privacy":"styles_privacy__Ny6Be"};